import React, { Component } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

export default class GenerateCert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            text: this.props.previewText || "",
        };
    }
    handleChange = (value) => {
        this.setState({
            text: value,
        });
        this.props.handleUpdate(value);
    };

    render() {
        var toolbarOptions = [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean'],
        ];
        var modules = {
            toolbar: {
                container: toolbarOptions,  // Selector for toolbar container

            }
        };
        return (
            <div>
                <ReactQuill value={this.state.text} onChange={this.handleChange} modules={modules} />{" "}
                {/* <button
          onClick={this.handleUpdate(this.state.text)}
          class="btn btn-warning ml-3 mb-3 mr-3"
        >
          Update Certificate
        </button>{" "} */}
            </div >
        );
    }
}
